export default {
  mobile: '@media only screen and (max-width: 770px)',
}
